import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=b1284988&"
import script from "./ControlPanel.vue?vue&type=script&lang=js&"
export * from "./ControlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports